// src/components/AppRoutes.js
import React from 'react';
import {Route,Switch} from 'react-router-dom';
import u from "../utilities/Utilities";
import '../styles/app.scss';


export default class AppRoutes extends React.Component {

    componentDidMount=()=>{
        this.resize();
        window.addEventListener("resize",this.resize);
    }

    componentWillUnmount=()=>{
        window.removeEventListener("resize",this.resize);
    }

    resize=()=>{
        const pageRoot = document.getElementById("root");

        if(!u.isiOS()){
            pageRoot.style.height = window.innerHeight +"px";
        }
        else{
            pageRoot.style.height = screen.height +"px";
        }
    }

    render=()=>{
        return (
            <Switch>
                <Route exact={true} path="/" component={Landing}/>
                <Route path="/login" component={Landing}/>
                <Route path="/create-user" component={CreateUser}/>
                <Route path="/reset-password" component={ResetPassword}/>
                <Route path="/download-file/:filestamp/:filename" component={Download}/>
                <Route path="/dashboard" component={Dashboard}/>
                <Route path="/submit-vitals/:dormCode" component={SubmitVitals}/>

                <Route path="/absence-reason-list" component={AbsenceReasonList}/>
                <Route path="/accessory-list" component={AccessoryList}/>
                <Route path="/agreement-list" component={AgreementList}/>
                <Route path="/agreement/:agreementID" component={Agreement}/>
                <Route path="/attendance-event-list" component={AttendanceEventList}/>
                <Route path="/attendance-list" component={AttendanceList}/>
                <Route path="/bulletin-list" component={AnnouncementList}/>
                <Route path="/booking-list" component={BookingList}/>
                <Route path="/client-list" component={ClientList}/>
                <Route path="/client/:clientID" component={Client}/>
                <Route path="/estate-list/:type/:id" component={Estate}/>
                <Route path="/exit-request-list" component={ExitRequestList}/>
                <Route path="/facility-list" component={FacilityList}/>
                <Route path="/form-list" component={FormList}/>
                <Route path="/feedback-list" component={FeedbackList}/>
                <Route path="/history-list" component={HistoryList}/>
                <Route path="/hoto-list" component={HandTakeOverList}/>
                <Route path="/hoto-item-list" component={HotoItemList}/>
                <Route path="/incident-list" component={IncidentList}/>
                <Route path="/incident-statement/:sid" component={IncidentStatement}/>
                <Route path="/incident-closure/:id" component={IncidentClosure}/>
                <Route path="/handover-report" component={HandoverReport}/>
                <Route path="/misconduct-list" component={MisconductList}/>
                <Route path="/misconduct-incident-report" component={MisconductIncidentReport}/>
                <Route path="/announcement-list" component={NotificationList}/>
                <Route path="/offense-list" component={OffenseList}/>
                <Route path="/permission-list" component={PermissionGroupList}/>
                <Route path="/report-sick-list" component={ReportSickList}/>
                <Route path="/print-card" component={PrintCard}/>
                <Route path="/print-dorm" component={PrintDormQR}/>
                <Route path="/print-multiple-card" component={PrintMultipleCard}/>
                <Route path="/price-list" component={PriceList}/>
                <Route path="/reports" component={Reports}/>
                <Route path="/resident-list" component={ResidentList}/>
                <Route path="/resident/:tenantID" component={Resident}/>
                <Route path="/room-manifest" component={RoomManifest}/>
                <Route path="/staff-list" component={StaffList}/>
                <Route path="/staff/:staffID" component={Staff}/>
                <Route path="/security-list" component={SecurityList}/>
                <Route path="/scheduler-list" component={SchedulerList}/>
                <Route path="/survey-list" component={SurveyList}/>
                <Route path="/survey-result/:surveyID" component={SurveyResult}/>
                <Route path="/task-list" component={TaskList}/>
                <Route path="/task-report" component={TaskReport}/>
                <Route path="/takeover-report" component={TakeoverReport}/>
                <Route path="/transfer-list" component={TransferList}/>
                <Route path="/work-sites" component={TaskGroupPage}/>
                <Route path="/usage-report" component={UsageReport}/>
                <Route path="/visitor-list" component={VisitorList}/>
                <Route path="/visitor-self-submission/:dormCode" component={VisitorSelfSubmission}/>
                <Route path="/visitor-card" component={VisitorCard}/>
                <Route path="/vitals-dashboard/:dormID" component={VitalsDashboard}/>
                <Route path="/vcard/:dormCode/:vcardLink" component={StaffVCard}/>
                <Route path="/event-print-qr" component={PrintAttendanceEvent}/>

                <Route path="/psa-resident-status/:dormID" component={PSAResidentStatus}/>
                <Route path="/psa-operational-statistics/:dormID" component={PSAOperationalStatistics}/>
                <Route path="/psa-operational-status/:dormID" component={PSAOperationalStatus}/>
                <Route path="/psa-room-status/:dormID" component={PSARoomStatus}/>
                <Route path="/psa-ppr-dorm-layout/:dormID" component={PSAPPRDormLayout}/>
                <Route path="/psa-br-dorm-layout/:dormID" component={PSABRDormLayout}/>
                <Route path="/teeup-dorm-layout/:dormID" component={TeeUpDormLayout}/>

                <Route path="/store" component={StorePage}/>
                <Route path="/inventory/:id" component={InventoryPage}/>
                <Route path="/inventory-item-list" component={InventoryItemList}/>
                <Route path="/store-activity" component={StoreActivityList}/>
                <Route path="/store-item-list" component={StoreItemList}/>
                <Route path="/item-supplier-list" component={ItemSupplierList}/>
                <Route path="/purchase-order-list" component={PurchaseOrderList}/>
                <Route path="/job-experience-list" component={JobExperienceList}/>
                <Route path="/medical-record-list" component={MedicalRecordList}/>
                <Route path="/reward-item-list" component={RewardItemList}/>
                <Route path="/reward-exchange-list" component={RewardExchangeList}/>
                <Route path="/training-list" component={TrainingList}/>
                <Route path="/qualification-list" component={QualificationList}/>
                <Route path="/appointment-list" component={AppointmentList}/>
                <Route path="/appointment-assigned-list" component={AppointmentAssignList}/>
                <Route path="/trait-list" component={TraitList}/>
                <Route path="/trait-assigned-list" component={TraitAssignList}/>
                <Route path="/e-learning-module-list" component={ELearningModuleList}/>
                <Route path="/course-list" component={CourseList}/>
                <Route path="/quiz-list" component={QuizList}/>
                <Route path="/quiz-attempt-list" component={QuizAttemptList}/>
                <Route path="/point-history-list" component={PointHistoryList}/>
                <Route path="/safety-shoutout-list" component={SafetyShoutoutList}/>
                <Route path="/site-list" component={SiteList}/>
                <Route path="/subcon-list" component={SubconList}/>

                <Route path="*" component={NotFound}/>
            </Switch>
        );
    }
}

import AbsenceReasonList from '../pages/AbsenceReasonList';
import AccessoryList from '../pages/AccessoryList';
import AgreementList from '../pages/AgreementList';
import Agreement from '../pages/Agreement';
import AnnouncementList from '../pages/AnnouncementList';
import AttendanceEventList from '../pages/AttendanceEventList';
import AttendanceList from '../pages/AttendanceList';
import BookingList from '../pages/BookingList';
import ClientList from '../pages/ClientList';
import Client from '../pages/Client';
import CreateUser from '../pages/CreateUser';
import Dashboard from '../pages/Dashboard';
import Download from '../pages/Download';
import Estate from '../pages/Estate';
import ExitRequestList from '../pages/ExitRequestList';
import FacilityList from '../pages/FacilityList';
import FormList from '../pages/FormList';
import FeedbackList from '../pages/FeedbackList';
import HistoryList from '../pages/HistoryList';
import HandTakeOverList from '../pages/HandTakeOverList';
import HandoverReport from '../pages/HandoverReport';
import HotoItemList from '../pages/HotoItemList';
import IncidentList from '../pages/IncidentList';
import IncidentStatement from '../pages/IncidentStatement';
import IncidentClosure from '../pages/IncidentClosure';
import Landing from '../pages/Landing';
import MisconductList from '../pages/MisconductList';
import MisconductIncidentReport from '../pages/MisconductIncidentReport';
import NotFound from '../pages/NotFound';
import NotificationList from '../pages/NotificationList';
import OffenseList from '../pages/OffenseList';
import PermissionGroupList from '../pages/PermissionGroupList';
import ReportSickList from '../pages/ReportSickList';
import PrintCard from '../pages/PrintCard';
import PrintDormQR from '../pages/PrintDormQR';
import PrintMultipleCard from '../pages/PrintMultipleCard';
import PriceList from '../pages/PriceList';
import Reports from '../pages/Reports';
import ResidentList from '../pages/ResidentList';
import Resident from '../pages/Resident';
import ResetPassword from '../pages/ResetPassword';
import RoomManifest from '../pages/RoomManifest';
import SchedulerList from '../pages/SchedulerList';
import StaffList from '../pages/StaffList';
import Staff from '../pages/Staff';
import StaffVCard from '../pages/StaffVCard';
import SecurityList from '../pages/SecurityList';
import SubmitVitals from '../pages/SubmitVitals';
import SurveyList from '../pages/SurveyList';
import SurveyResult from '../pages/SurveyResult';
import TaskList from "../pages/TaskList";
import TaskReport from '../pages/TaskReport';
import TaskGroupPage from '../pages/TaskGroupPage';
import PrintAttendanceEvent from '../pages/PrintAttendanceEvent';
import TakeoverReport from '../pages/TakeoverReport';
import TransferList from '../pages/TransferList';
import UsageReport from '../pages/UsageReport';
import VisitorList from '../pages/VisitorList';
import VisitorCard from '../pages/VisitorCard';
import VisitorSelfSubmission from '../pages/VisitorSelfSubmission';
import VitalsDashboard from '../pages/VitalsDashboard';
import JobExperienceList from '../pages/JobExperienceList';
import MedicalRecordList from '../pages/MedicalRecordList';


//PSA Only -- Kept for demo purposes
import PSAResidentStatus from '../pages/dashboards/PSAResidentStatus';
import PSAOperationalStatistics from '../pages/dashboards/PSAOperationalStatistics';
import PSAOperationalStatus from '../pages/dashboards/PSAOperationalStatus';
import PSARoomStatus from '../pages/dashboards/PSARoomStatus';
import PSAPPRDormLayout from '../pages/dashboards/PSAPPRDormLayout';
import PSABRDormLayout from '../pages/dashboards/PSABRDormLayout';
import TeeUpDormLayout from '../pages/dashboards/TeeUpDormLayout';

//Inventory Module
import InventoryPage from '../pages/inventory/InventoryComponent';
import InventoryItemList from '../pages/inventory/InventoryItemList';
import ItemSupplierList from '../pages/inventory/ItemSupplierList';
import PurchaseOrderList from '../pages/inventory/PurchaseOrderList';
import StoreActivityList from '../pages/inventory/StoreActivityList';
import StoreItemList from '../pages/inventory/StoreItemList';
import StorePage from '../pages/inventory/Store';

import RewardItemList from '../pages/RewardItemList';
import RewardExchangeList from '../pages/RewardExchangeList';
import ELearningModuleList from '../pages/ELearningModuleList';
import CourseList from '../pages/CourseList';
import QuizList from '../pages/QuizList';
import QuizAttemptList from '../pages/QuizAttemptList';
import PointHistoryList from '../pages/PointHistory';
import SafetyShoutoutList from '../pages/ShoutoutList';
import TrainingList from '../pages/TrainingList';
import QualificationList from '../pages/QualificationList';
import TraitList from '../pages/TraitList';
import TraitAssignList from '../pages/TraitAssignList';
import AppointmentList from '../pages/AppointmentList';
import AppointmentAssignList from '../pages/AppointmentAssignList';
import SiteList from '../pages/SiteList';
import SubconList from '../pages/SubconList';